export enum DayOfWeekEnum {
  sunday,
  monday,
  tuesday,
  wednesday,
  thursday,
  friday,
  saturday,
}

export enum PublishStatusEnum {
  draft = 1,
  preview,
  public,
}

export enum SortOrderEnum {
  asc = 1,
  desc,
}

/************************* Company users *************************/
export enum CompanyUsersSortByEnum {
  surname = 1,
  since,
}

/************************* Company clients *************************/
export enum CompanyClientsSortByEnum {
  name = 1,
  datetimeInserted,
  bookings,
  surname,
  level,
}

export enum RegistrationEnum {
  HaveFun = 1,
  Facebook,
  Google,
  Apple,
}

export enum ContactTypeEnum {
  Email = 1,
  MobilePhone,
}

/************************* Company teams *************************/
export enum TeamRoleEnum {
  Captain = 1,
  Player = 2,
  SecondaryCaptain,
}

export enum CompanyTeamsSortByEnum {
  name = 1,
  totalBookings,
}

/************************* Academies *************************/
export enum AcademyRoleEnum {
  Trainer = 1,
  Player = 2,
  SecondaryTrainer,
}

export enum CompanyAcademiesSortByEnum {
  name = 1,
  totalBookings,
}

/************************* Social login *************************/
export enum LoginProvidersEnum {
  HaveFun = 1,
  Facebook,
  Google,
  Apple,
}

/************************* Bookings *************************/
export enum BookingTypeEnum {
  Other,
  Friendly,
  Tournament,
  Training,
  Party,
  Event,
  SchoolTrip,
}

export enum RecurringBookingStatusEnum {
  Pending = 0,
  Active,
  Cancelled,
}

export enum CancellationReasonVisibilityEnum {
  None,
  Business,
  Client,
  Both,
}

export enum AppClientEnum {
  suite = 1,
  suitePocket,
  haveFun,
}

export enum UpdateBookingActionEnum {
  None = 0,
  OnlyThis,
  AllFutured,
  AllFuturedFromCurrentDate,
  All,
}

export enum BookingStatusEnum {
  none = 0,
  autoApproved,
  cancelled,
  noShow,
}

export enum BookingsHistorySortByEnum {
  bookingDatetime = 1,
  bookedDatetime,
}

export enum BookingsHistoryStatusEnum {
  inProgress,
  completed,
  cancelled,
  noShow,
}

export enum BookingStageEnum {
  pending = 0,
  inProgress,
  completed,
  cancelled,
  noShow,
}

/************************* Exceptions *************************/
export enum ExceptionTypeEnum {
  Other,
  Tournament,
  Training,
  Maintenance,
  PublicHoliday,
  Party,
  HaveFunBlocked,
}

export enum ExceptionCategoryEnum {
  DateAndTime,
  Range,
  Recurring,
}
